var _defs, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGift = function SvgGift(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.569,
    height: 77.658,
    viewBox: "0 0 76.569 77.658",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.527,
    y1: 0.054,
    x2: 0.683,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#ffc000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e19807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_8",
    x: 0,
    y: 24.516,
    width: 76.569,
    height: 53.142,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb9400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.527,
    y1: 0.054,
    x2: 0.683,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd2a78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#db1e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0f29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1243",
    x: 18.544,
    y: 25.882,
    width: 40.71,
    height: 39.791,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b75503",
    floodOpacity: 0.631
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12005",
    "data-name": "Group 12005",
    transform: "translate(5.519 1.396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.52, -1.4)",
    filter: "url(#Subtraction_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8-2",
    "data-name": "Subtraction 8",
    d: "M51.17,35.142H7.4a3.9,3.9,0,0,1-3.882-3.477L0,0H58.569L55.051,31.665A3.908,3.908,0,0,1,51.17,35.142ZM29.892,23.182l0,.007,5.929,3.692a1.408,1.408,0,0,0,.77.235,1.5,1.5,0,0,0,1.161-.576,1.457,1.457,0,0,0,.268-1.272l-1.672-6.821,5.321-4.53a1.428,1.428,0,0,0,.467-1.566,1.447,1.447,0,0,0-1.286-1.03l-6.965-.507-2.634-6.52a1.464,1.464,0,0,0-2.709,0l-2.626,6.52-6.962.507a1.458,1.458,0,0,0-1.291,1.026,1.434,1.434,0,0,0,.45,1.57l5.331,4.53-1.672,6.821a1.456,1.456,0,0,0,.267,1.272,1.478,1.478,0,0,0,1.152.566,1.424,1.424,0,0,0,.77-.225l5.929-3.692Z",
    transform: "translate(9 30.52)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M319.094,119.486H285.651a1.915,1.915,0,0,1-1.914-1.419l-1.171-5.289a1.822,1.822,0,0,1,1.914-2.109H346.1a1.824,1.824,0,0,1,1.916,2.109l-1.173,5.289a1.911,1.911,0,0,1-1.914,1.419H312.342",
    transform: "translate(-282.527 -91.677)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 4.881,
    cy: 11.715,
    rx: 4.881,
    ry: 11.715,
    transform: "matrix(0.587, -0.81, 0.81, 0.587, 8.698, 7.906)",
    fill: "none",
    stroke: "#ffcc02",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 11.715,
    cy: 4.881,
    rx: 11.715,
    ry: 4.881,
    transform: "translate(29.85 11.443) rotate(-25.407)",
    fill: "none",
    stroke: "#ffcc02",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.52, -1.4)",
    filter: "url(#Path_1243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243-2",
    "data-name": "Path 1243",
    d: "M316.351,125.228l-7.12-.524-2.692-6.661a1.491,1.491,0,0,0-2.769,0l-2.692,6.661-7.12.524a1.508,1.508,0,0,0-.857,2.655l5.45,4.632-1.711,6.978a1.5,1.5,0,0,0,2.245,1.646l6.062-3.789,6.062,3.789a1.5,1.5,0,0,0,2.245-1.646l-1.711-6.978,5.45-4.632a1.5,1.5,0,0,0-.844-2.655Zm0,0",
    transform: "translate(-266.25 -83.47)",
    stroke: "#ffe89b",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    fill: "url(#linear-gradient-3)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGift, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };